import React, { useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile, faFilePdf, faFileAudio, faFileAlt, faFileVideo } from "@fortawesome/free-solid-svg-icons";

const ImagePreview = ({ file }) => {
    const imageRef = useRef();
    useEffect(() => {
        var reader = new FileReader();
        const $image = imageRef.current;
        reader.onload = function (e) {
            if ($image) {
                $image.setAttribute("src", e.target.result);
            }
        };
        reader.readAsDataURL(file);
    }, [file]);

    return <img ref={imageRef} id={`img_`} alt={`Product ${file.name}`} src="" />;
};

const useFileIcon = (file) => {
    const type = file.type || "";

    if (type.startsWith("image/")) {
        return <ImagePreview file={file} />;
    } else if (type === "application/pdf") {
        return <FontAwesomeIcon icon={faFilePdf} />;
    } else if (type.startsWith("audio/")) {
        return <FontAwesomeIcon icon={faFileAudio} />;
    } else if (type.startsWith("video/")) {
        return <FontAwesomeIcon icon={faFileVideo} />;
    } else if (type.startsWith("text/")) {
        return <FontAwesomeIcon icon={faFileAlt} />;
    } else {
        return <FontAwesomeIcon icon={faFile} />;
    }
};

const PreviewFile = ({ file }) => {
    return (
        <div>
            {useFileIcon(file)}
            <p>{file.name}</p>
        </div>
    );
};

export default PreviewFile;
